/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ size: NonNullable<unknown> }} Chat_Save_To_Space_SizeInputs */



/**
* | output |
* | --- |
* | "Size: {size}" |
*
* @param {Chat_Save_To_Space_SizeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_save_to_space_size = /** @type {((inputs: Chat_Save_To_Space_SizeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Save_To_Space_SizeInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Größe: ${i?.size}`)
	return /** @type {LocalizedString} */ (`Size: ${i?.size}`)
});